import React from 'react';

import PropTypes from 'prop-types';
import { Tab, TabList } from 'react-tabs';
import styled from 'styled-components';

import { desktop } from '~/techstyle-shared/react-components';

const SizeTabList = styled(TabList)`
  display: flex;
  flex-direction: row;
  list-style-type: none;
  justify-content: space-evenly;
  color: ${({ theme }) => theme.colors.textDefault};

  ${desktop`
    width: 80%;
    margin: auto;
  `}
`;
SizeTabList.tabsRole = 'TabList';

const SizeTab = styled(Tab)`
  padding-bottom: 12px;
  padding-top: 4px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.13;
  letter-spacing: ${-0.35 / 14}em;
  text-align: center;
  text-transform: uppercase;
  width: 50%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.sizeGridTabBorder};
  &.react-tabs__tab--selected {
    border-bottom: 2px solid ${({ theme }) => theme.colors.sizeGridSizeTab};
  }
`;
SizeTab.tabsRole = 'Tab';

const SizeGuideTable = styled.table`
  margin: 24px 0 14px;
  width: 100%;
  border: none;
  border-collapse: collapse;

  th {
    width: ${({ count }) => 100 / count}%;
  }
`;

const SizeGuideTableHead = styled.thead`
  text-transform: uppercase;
`;

const SizeGuideHeaderRow = styled.tr`
  font-weight: 600;
  font-size: 14px;
  height: 42px;
  color: ${({ theme }) => theme.colors.textLight};
  background: ${({ theme }) => theme.colors.backgroundEmphasized};
`;

const SizeGuideTableRow = styled.tr`
  height: 42px;
  &:nth-child(odd) {
    background: ${({ theme }) => theme.colors.backgroundLightAlternate};
  }
  &:hover {
    background: ${({ theme }) => theme.colors.backgroundEmphasizedLight};
  }
`;

const SizeGuideHead = styled.th``;

const SizeGuideBody = styled.tbody``;

const SizeGuideTableData = styled.td`
  text-align: center;
`;

export function SizeGrid({ columnHeadings = [], rowData }) {
  const headerKeys = Object.keys(columnHeadings);

  return (
    <SizeGuideTable count={headerKeys.length}>
      {headerKeys.length > 0 && (
        <SizeGuideTableHead>
          <SizeGuideHeaderRow>
            {headerKeys.map((key) => (
              <SizeGuideHead value={key} key={key}>
                {columnHeadings[key]}
              </SizeGuideHead>
            ))}
          </SizeGuideHeaderRow>
        </SizeGuideTableHead>
      )}
      <SizeGuideBody>
        {rowData.map((sizes) => (
          <SizeGuideTableRow key={sizes}>
            {sizes.map((size, index) => (
              <SizeGuideTableData key={`${size}-${index}`}>
                {size}
              </SizeGuideTableData>
            ))}
          </SizeGuideTableRow>
        ))}
      </SizeGuideBody>
    </SizeGuideTable>
  );
}

SizeGrid.propTypes = {
  columnHeadings: PropTypes.objectOf(PropTypes.string),
  rowData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

SizeGrid.TabList = SizeTabList;
SizeGrid.Tab = SizeTab;
